import Swiper from 'swiper/dist/js/swiper.min.js';

jQuery(document).ready(function($) {
  categoryLinks($)

  if (!$('.news').length) {
    return;
  }

  news($);
});

function news($) {
  if ($(window).width() <= 800) {
    new Swiper('.news-list', {
      spaceBetween: 40,
      slidesPerView: 1,
      pagination: {
        el: '.news-pagination',
        clickable: true,
      },
    });
  }
}

function categoryLinks($) {
  if($('.main-blog__categories .current-cat').length) {
    const blogUrl = $('.main-blog__categories').data('blog-url');
    $('.main-blog__categories .current-cat a').attr('href', blogUrl);
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/news.js